export enum DocumentSystemType {
    DEFAULT             = 1,
    PAGE                = 2,

    WHITEBOARD          = 3,
    WHITEBOARD_RESOURCE = 4
}
